module.exports = __webpack_public_path__ + "img/icon-stopwatch.0817a41c.svg";